import { jsx } from "react/jsx-runtime";
import DOMPurify from "dompurify";
import { useState, useEffect } from "react";
const svgPromiseCache = /* @__PURE__ */ new Map();
const svgResolvedCache = /* @__PURE__ */ new Map();
const isSvgUrl = (url) => /\.svg(\?.*)?$/i.test(url);
const normalizeSvgMarkup = (svg) => svg.replace(/<svg\b([^>]*)>/i, (_match, attrs) => {
  const cleaned = attrs.replace(/\swidth="[^"]*"/gi, "").replace(/\sheight="[^"]*"/gi, "").replace(/\sstyle="[^"]*"/gi, "");
  return `<svg${cleaned} width="100%" height="100%" style="display:block">`;
});
const fetchSvg = (url) => {
  const cached = svgPromiseCache.get(url);
  if (cached) return cached;
  const promise = fetch(url, { credentials: "omit" }).then((res) => res.ok ? res.text() : null).then((raw) => {
    if (!raw) return null;
    const sanitized = DOMPurify.sanitize(raw, {
      USE_PROFILES: { svg: true, svgFilters: true }
    });
    return normalizeSvgMarkup(sanitized);
  }).catch(() => null).then((markup) => {
    svgResolvedCache.set(url, markup);
    return markup;
  });
  svgPromiseCache.set(url, promise);
  return promise;
};
const InlineSvgIcon = ({ src, alt, style, className }) => {
  const isSvg = isSvgUrl(src);
  const [markup, setMarkup] = useState(() => {
    if (!isSvg) return null;
    if (svgResolvedCache.has(src)) return svgResolvedCache.get(src);
    return void 0;
  });
  useEffect(() => {
    if (!isSvg) {
      setMarkup(null);
      return;
    }
    if (svgResolvedCache.has(src)) {
      setMarkup(svgResolvedCache.get(src));
      return;
    }
    let cancelled = false;
    void fetchSvg(src).then((m) => {
      if (!cancelled) setMarkup(m);
    });
    return () => {
      cancelled = true;
    };
  }, [src, isSvg]);
  if (isSvg && markup === void 0) {
    const { objectFit: _dropped, ...restStyle } = style ?? {};
    return /* @__PURE__ */ jsx(
      "span",
      {
        "aria-hidden": true,
        className,
        style: { display: "flex", alignItems: "center", justifyContent: "center", ...restStyle }
      }
    );
  }
  if (isSvg && markup) {
    const { objectFit: _dropped, ...restStyle } = style ?? {};
    return /* @__PURE__ */ jsx(
      "span",
      {
        role: "img",
        "aria-label": alt,
        className,
        style: { display: "flex", alignItems: "center", justifyContent: "center", ...restStyle },
        dangerouslySetInnerHTML: { __html: markup }
      }
    );
  }
  return /* @__PURE__ */ jsx("img", { src, alt, className, style });
};
export {
  InlineSvgIcon
};
//# sourceMappingURL=InlineSvgIcon.js.map
